import { Record, List } from 'immutable'

export const GalleryRecord = Record({
  pending: false,
  images: List(),
  selected: false,
  loaded: false,
  imageToDelete: null,
  search: '',
  isImageNameExist: false,
  isButtonDisable: true,
})

export class Gallery extends GalleryRecord {}
